import { Injectable } from '@angular/core';
import { LogService } from 'app/_services/logmanager.service';
import { DataService } from 'app/_services/datamanager.service';
import { AlertService } from 'app/_services/alert.service';
import { GlobalsService } from 'app/_services/globals.service';

@Injectable()
export class LoginAs {
    errorMessage: string;

    constructor(
        private alertService: AlertService,
        private dataService: DataService,
        private globalStorage: GlobalsService
    ) {
    }

    loginAsAnotherUser (username = '') {
        const params = <any>{
            'accio': 'WsLoginAs',
            'params': <any>{
                'secretaria_id' : this.globalStorage.getItem('secretaria'),
                'newUsername' : username
            }
        };
        this.dataService.getData(params).subscribe(
            data => {
                if (data[0] !== 0) {
                    this.globalStorage.setItem('searchUser', data[0]);
                } else {
                    this.globalStorage.removeItem('searchUser');
                }
                LogService.log('LoginAsService', 'this->globalStorage eliminat.');
            },
            error => {
                this.errorMessage = <any>error;
                this.alertService.error(this.errorMessage);
            },
            () => {
                window.location.href = 'welcome';
            });
    }
}
